import { API } from '~/data/api'
import { type TripData } from '~/types/trip'

export const useTripService = () => {
  const interactionStore = useInteractionStore()

  async function getTrip(id: string) {
    const response = await API.getTrip(id)

    if (response?.data) {
      interactionStore.initItem('trips', response.data.id, {
        likedByMe: response.data.liked_by_me,
        likeCount: response.data.likes_count,
        commentCount: response.data.comments_count
      })
    }

    return response?.data
  }

  async function calculateTripRoute(id: number) {
    const response = await API.calculateTripRoute(id)
    return response?.data
  }

  async function deleteTrip(id: string) {
    const response = await API.deleteTrip(id)
    return response?.data as TripData
  }

  async function updateTrip(
    id: string,
    data: {
      title: string
      note: string
      weather: any
      friend_ids: string[]
      hide_max_speed: boolean
      bike_id: string
      truncate_trails: boolean
      privacy: string
    }
  ) {
    const response = await API.putTrip(id, data)
    return response
  }

  async function updateTripPhotos(data: FormData) {
    const response = await API.putTripPhotos(data)
    return response
  }

  async function deletePhoto(id: string) {
    return await API.deletePhoto(id)
  }

  async function getPublicTrip(token: string) {
    const response = await API.getPublicTrip(token)
    return response?.data as TripData
  }

  async function getPublicTripPolyline(token: string) {
    const response = await API.getPublicTripPolyline(token)
    return response?.data
  }

  async function shareTripEvent(id: string) {
    const response = await API.createEvent(id, 'SHARE', 'TRIP')
    return response?.data
  }

  return {
    getTrip,
    calculateTripRoute,
    deleteTrip,
    updateTrip,
    updateTripPhotos,
    deletePhoto,
    getPublicTrip,
    getPublicTripPolyline,
    shareTripEvent
  }
}
